import { Pipe, PipeTransform } from '@angular/core';
import { PURCHASE_ORDER_STATUS_LABELS } from './purchase-order-status.constants';
import { PurchaseOrderStatus } from './purchase-order-status.enum';

@Pipe({
    name: 'purchaseOrderStatus',
})
export class PurchaseOrderStatusPipe implements PipeTransform {
    transform(value: string): string {
        return PURCHASE_ORDER_STATUS_LABELS[value as PurchaseOrderStatus] ?? value;
    }
}
